export default __webpack_public_path__ + "static/media/coupon-llantas.5116a6c2.jpeg";